//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    imageUrls: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      currentFrame: 1,
      isDragging: false,
      startX: 0,
      lastFrame: 1,
      isLoading: true,
      imagesLoaded: 0,
      localImages: [],
      isPlaying: false,
      playInterval: null,
      isModalOpen: false,
      modalFrame: 1,
      modalIsPlaying: false,
      modalIsPaused: false,
      modalPlayInterval: null,
      modalZoom: 1.0, // Значение увеличения (1.0 - 100%)
      isPanning: false,
      panStartX: 0,
      panStartY: 0,
      panX: 0,
      panY: 0,
      isDarkTheme: false,
    };
  },
  methods: {
    preloadImage(url) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = url;
        img.onload = () => {
          resolve(img.src);
        };
        img.onerror = reject;
      });
    },
    preloadImages() {
      this.localImages = new Array(this.imageUrls.length);
      this.imagesLoaded = 0;

      const preloadPromises = this.imageUrls.map((url, index) => {
        return this.preloadImage(url).then((src) => {
          this.localImages[index] = src;
          this.imagesLoaded++;
          if (this.imagesLoaded >= this.imageUrls.length) {
            this.isLoading = false;
          }
        }).catch(() => {
          this.imagesLoaded++;
          if (this.imagesLoaded >= this.imageUrls.length) {
            this.isLoading = false;
          }
        });
      });

      // Ждем загрузки всех изображений
      Promise.all(preloadPromises);
    },
    // // Открываем IndexedDB
    // openDatabase() {
    //   return new Promise((resolve, reject) => {
    //     const request = indexedDB.open("ImageCache", 1);

    //     request.onupgradeneeded = (event) => {
    //       const db = event.target.result;
    //       if (!db.objectStoreNames.contains("images")) {
    //         db.createObjectStore("images", { keyPath: "url" });
    //       }
    //     };

    //     request.onsuccess = (event) => resolve(event.target.result);
    //     request.onerror = (event) => reject(event.target.error);
    //   });
    // },

    // // Проверяем наличие изображения в IndexedDB
    // getImageFromCache(url) {
    //   return new Promise((resolve, reject) => {
    //     this.openDatabase().then((db) => {
    //       const transaction = db.transaction("images", "readonly");
    //       const store = transaction.objectStore("images");
    //       const request = store.get(url);

    //       request.onsuccess = (event) => {
    //         const result = event.target.result;
    //         if (result) {
    //           const objectURL = URL.createObjectURL(result.src);
    //           resolve(objectURL);
    //         } else {
    //           this.loadImage(url).then((src) => resolve(src));
    //         }
    //       };

    //       request.onerror = (event) => reject(event.target.error);
    //     }).catch(reject);
    //   });
    // },
    // // Загружаем изображение как Blob и сохраняем его в IndexedDB
    // loadImage(url) {
    //   return new Promise((resolve, reject) => {
    //     const img = new Image();
    //     img.crossOrigin = 'anonymous'; // Включение CORS
    //     img.src = url;
    //     img.onload = () => {
    //       this.openDatabase().then((db) => {
    //         const transaction = db.transaction("images", "readwrite");
    //         const store = transaction.objectStore("images");
            
    //         // Конвертируем изображение в Blob
    //         const canvas = document.createElement("canvas");
    //         const ctx = canvas.getContext("2d");
    //         canvas.width = img.width;
    //         canvas.height = img.height;
    //         ctx.drawImage(img, 0, 0);
    //         canvas.toBlob((blob) => {
    //           store.put({ url, src: blob });
    //           const objectURL = URL.createObjectURL(blob);
    //           resolve(objectURL);
    //         }, "image/webp");
    //       }).catch(reject);
    //     };
    //     img.onerror = reject;
    //   });
    // },
    // preloadImages() {
    //   this.localImages = new Array(this.imageUrls.length);
    //   this.imagesLoaded = 0;

    //   const preloadPromises = this.imageUrls.map((url, index) => {
    //     return this.getImageFromCache(url).then((src) => {
    //       this.localImages[index] = src;
    //       this.imagesLoaded++;
    //       if (this.imagesLoaded >= this.imageUrls.length) {
    //         this.isLoading = false;
    //       }
    //     }).catch(() => {
    //       this.imagesLoaded++;
    //       if (this.imagesLoaded >= this.imageUrls.length) {
    //         this.isLoading = false;
    //       }
    //     });
    //   });

    //   // Ждем загрузки всех изображений
    //   Promise.all(preloadPromises);
    // },
    toggleTheme() {
      this.isDarkTheme = !this.isDarkTheme;
    },
    togglePanning() {
      this.isPanning = !this.isPanning;
    },
    toggleAutoPlay() {
      if (this.isPlaying) {
        clearInterval(this.playInterval);
        this.isPlaying = false;
      } else {
        this.isPlaying = true;
        this.disableUserInput(true); // блокируем ввод пользователя
        let count = 0;
        this.playInterval = setInterval(() => {
          if (this.currentFrame < this.imageUrls.length) {
            this.currentFrame++;
          } else {
            this.currentFrame = 1;
            count++;
            if (count >= 1) { // Останавливаем автоплей после одного оборота
              clearInterval(this.playInterval);
              this.isPlaying = false;
              this.disableUserInput(false); // разблокируем ввод пользователя
            }
          }
        }, 100);
      }
    },
    toggleModalAutoPlay() {
      if (this.modalIsPlaying) {
        clearInterval(this.modalPlayInterval);
        this.modalIsPlaying = false;
        this.modalIsPaused = true;
      } else {
        this.modalIsPlaying = true;
        this.modalIsPaused = false;
        this.disableUserInput(true);
        let count = 0;
        this.modalPlayInterval = setInterval(() => {
          if (this.modalFrame < this.imageUrls.length) {
            this.modalFrame++;
          } else {
            this.modalFrame = 1;
            count++;
            if (count >= 1) {
              clearInterval(this.modalPlayInterval);
              this.modalIsPlaying = false;
              this.disableUserInput(false);
            }
          }
        }, 100);
      }
    },
    disableUserInput(disabled) {
      const imageWrapper = this.$el.querySelector('.image-wrapper');
      if (disabled) {
        imageWrapper.style.pointerEvents = 'none'; // блокируем взаимодействие
      } else {
        imageWrapper.style.pointerEvents = ''; // разблокируем взаимодействие
      }
    },
    prevFrame() {
      if (this.isPlaying) return; // Если автоплей идет, кнопка не работает
      this.currentFrame = this.currentFrame === 1 ? this.imageUrls.length : this.currentFrame - 1;
    },
    nextFrame() {
      if (this.isPlaying) return; // Если автоплей идет, кнопка не работает
      this.currentFrame = this.currentFrame === this.imageUrls.length ? 1 : this.currentFrame + 1;
    },
    prevModalFrame() {
      if (this.modalIsPlaying) return;
      this.modalFrame = this.modalFrame === 1 ? this.imageUrls.length : this.modalFrame - 1;
    },
    nextModalFrame() {
      if (this.modalIsPlaying) return;
      this.modalFrame = this.modalFrame === this.imageUrls.length ? 1 : this.modalFrame + 1;
    },
    onMouseDown(event) {
      if (this.isLoading || event.button !== 0 || this.isPlaying) return;
      this.isDragging = true;
      this.startX = event.clientX;
      this.lastFrame = this.currentFrame;
    },
    onModalMouseDown(event) {
      if (this.isLoading || event.button !== 0 || this.modalIsPlaying) return;
      if (this.isPanning) {
        this.panStartX = event.clientX - this.panX;
        this.panStartY = event.clientY - this.panY;
        this.isDragging = true;
      } else {
        this.isDragging = true;
        this.startX = event.clientX;
        this.lastFrame = this.modalFrame;
      }
    },
    onMouseMove(event) {
      if (!this.isDragging || this.isLoading || this.isPlaying) return;
      this.updateFrame(event.clientX);
    },
    onModalMouseMove(event) {
      if (!this.isDragging || this.modalIsPlaying) return;
      if (this.isPanning) {
        this.panX = event.clientX - this.panStartX;
        this.panY = event.clientY - this.panStartY;
      } else {
        this.updateModalFrame(event.clientX);
      }
    },
    onMouseUp() {
      this.isDragging = false;
    },
    onModalMouseUp() {
      this.isDragging = false;
    },
    onTouchStart(event) {
      if (this.isLoading || this.isPlaying) return;
      this.isDragging = true;
      this.startX = event.touches[0].clientX;
      this.lastFrame = this.currentFrame;
    },
    onModalTouchStart(event) {
      if (this.isLoading || this.modalIsPlaying) return;
      this.isDragging = true;
      this.startX = event.touches[0].clientX;
      this.panStartX = event.touches[0].clientX - this.panX;
      this.panStartY = event.touches[0].clientY - this.panY;
      this.lastFrame = this.currentFrame;
    },
    onTouchMove(event) {
      if (!this.isDragging || this.isLoading || this.isPlaying) return;
      this.updateFrame(event.touches[0].clientX);
    },
    onModalTouchMove(event) {
      if (!this.isDragging || this.isLoading || this.modalIsPlaying) return;
      if (this.isPanning) {
        this.panX = event.touches[0].clientX - this.panStartX;
        this.panY = event.touches[0].clientY - this.panStartY;
      } else {
        this.updateModalFrame(event.touches[0].clientX);
      }
    },
    onTouchEnd() {
      this.isDragging = false;
    },
    onModalTouchEnd() {
      this.isDragging = false;
    },
    updateFrame(currentX) {
      const diff = currentX - this.startX;
      const step = Math.floor(diff / 5);
      this.currentFrame = ((this.lastFrame + step - 1 + this.imageUrls.length) % this.imageUrls.length) + 1;
      if (this.currentFrame < 0 || this.currentFrame > 72) {
        this.currentFrame = 1
      }
    },
    updateModalFrame(currentX) {
      const diff = currentX - this.startX;
      const step = Math.floor(diff / 5);
      this.modalFrame = ((this.lastFrame + step - 1 + this.imageUrls.length) % this.imageUrls.length) + 1;
      if (this.modalFrame < 0 || this.modalFrame > 72) {
        this.modalFrame = 1
      }
    },
    openModal() {
      this.modalFrame = this.currentFrame; // Синхронизируем, но дальше состояния независимы
      this.isModalOpen = true;
      document.body.style.overflow = 'hidden';
    },
    closeModal() {
      this.isModalOpen = false;
      clearInterval(this.modalPlayInterval);
      this.modalIsPlaying = false;
      document.body.style.overflow = '';
    },
    zoomIn() {
      if (this.modalZoom < 3.0) {
        this.modalZoom = Math.min(this.modalZoom + 0.1, 3.0);
      }
    },
    zoomOut() {
      if (this.modalZoom > 0.5) {
        this.modalZoom = Math.max(this.modalZoom - 0.1, 0.5);
      }
    },
    syncView() {
      if (!this.modalIsPlaying) {
        this.modalZoom = 1.0; // Сброс зума
        this.modalFrame = 1; // Установить первый кадр
        this.panX = 0;
        this.panY = 0;
        this.panStartX = 0;
        this.panStartY = 0;
        this.isPanning = false;
        this.modalIsPaused = false;
      }
    }
  },
  mounted() {
    this.preloadImages();
  }
};
